export default __webpack_public_path__ + "static/media/baby1.d802230d.png";